import { sortDescending, TEnv, TPayment } from "swiipe.portal.shared"
import { IShopifyAppUrls } from "../store/reducers/shopifySlice"

export function getBestShopifyAppUrls(appUrls: IShopifyAppUrls[], env: TEnv) {
    if (appUrls.length < 1) {
        return undefined
    }
    const sorted = sortDescending(
        appUrls,
        (au) => calculateHandlePrioritation(au.handle, env) * 10 + calculatePaymentTypePrioritation(au.paymentType, env)
    )
    return sorted[0]
}

const testEnvs: TEnv[] = ["Betatest", "Development", "Test", "Test2", "QA"]
function calculateHandlePrioritation(handle: string, env: TEnv) {
    if (handle.startsWith("swiipe-test-") || handle.startsWith("aera-test-")) {
        return testEnvs.includes(env) ? 10 : 0
    }
    if (handle.startsWith("swiipe-local-") || handle.startsWith("aera-local-")) {
        return 3
    }

    return testEnvs.includes(env) ? 0 : 10
}

function calculatePaymentTypePrioritation(paymentType: TPayment | undefined, env: TEnv) {
    return paymentType === "CreditCard" ? 2 : 1
}
